import React from 'react'
import { useHistory, Link } from 'react-router-dom'
import {
  Checkbox,
  ButtonSecondary,
  AlertError
} from '../../../components'
import styles from './main-content.module.css'
import accountService from '../../../features/account/service'
import { FormBasic } from './form-basic'
import { FormContact } from './form-contact'
import { FormAccount } from './form-account'
import DevLogger from '../../../components/_dev-logger'
import { useSelector } from 'react-redux'
const { createAccount } = accountService

const ACCOUNT_TYPE = 2

const Form = () => {
  const translation = useSelector(state => state.translation.data)
  const language = useSelector(state => state.system.language)
  const history = useHistory()
  const [form, setForm] = React.useState({})
  const [requesting, setRequesting] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState(null)
  const [agreed, setAgreed] = React.useState(false)

  const formIsValid = () => {
    console.log('organization registration form:', form)
    let validationErrorMessage = ''

    const {
      province,
      city,
      pin_point,
      approach,
      audience,
      issue,
      type
    } = form

    if(!province){
      validationErrorMessage += 'Province is required. '
    }
    if(!city){
      validationErrorMessage += 'City is required. '
    }
    if(!pin_point){
      validationErrorMessage += 'Pin Point is required. '
    }
    if(!approach || approach.length === 0){
      validationErrorMessage += 'Approaches is required. '
    }
    if(!audience || audience.length === 0){
      validationErrorMessage += 'Audience is required. '
    }
    if(!issue || issue.length === 0){
      validationErrorMessage += 'Issues is required. '
    }
    if(!type || type.length === 0){
      validationErrorMessage += 'Organization Type is required. '
    }

    if(validationErrorMessage === ''){
      return true
    } else {
      setErrorMessage(validationErrorMessage)
      return false
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setErrorMessage(null)
    setRequesting(true)

    if(formIsValid()){
      if(agreed){
        console.log('form:', form)

        /** Activate code below in case API not working */
        // let c = window.confirm('Registration system is not implemented yet. Do you want to continue to homepage?')
        // if (c) history.push('/register-organization-confirmation')

        /*
          'form' will be adapted to match API data structure
          with /features/account/adapter
        */

        // Use account service
        createAccount(form, ACCOUNT_TYPE)
        .then(res => {
          history.push('/register-organization-confirmation')
        })
        .catch(err => {
          setErrorMessage(err)
        })
        .then(() => setRequesting(false))
      } else {
        setErrorMessage('You must agree with the Terms and Conditions.')
        setRequesting(false)
      }
    } else {
      setRequesting(false)
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <DevLogger data={form} />

      <div className={styles.section}>
        <FormBasic onChange={(e) => setForm({...form, ...e})} />
      </div>

      <div className={styles.section}>
        <FormContact onChange={(e) => setForm({...form, ...e})} />
      </div>

      <div className={styles.section}>
        <FormAccount onChange={(e) => setForm({...form, ...e})} />
      </div>

      <div className={styles.section}>
        <Checkbox
          rounded
          label={
            <span>
              {translation.GENERAL.tnc_intro[language.name]}{" "}
              <Link to="/terms-conditions" className="underline">
                {translation.GENERAL.tnc[language.name]}
              </Link>
            </span>
          }
          onChange={(e) => setAgreed(e.target.checked)}
        />
      </div>

      <DevLogger data={form}/>

      <ButtonSecondary disabled={requesting} isLoading={requesting}>
        {translation.GENERAL.submit_now[language.name]}
      </ButtonSecondary>

      {errorMessage && (
        <AlertError
          message={errorMessage}
          onClose={() => setErrorMessage(null)}
        />
      )}
    </form>
  );
}

export { Form }
